import { Typography } from "antd";
import styled from "styled-components";

import { FONT_VARIANTS, FONT_WEIGHTS } from "../Typography.constants";
import { TParagraphStyleProps } from "./Paragraph.types";

export const ParagraphStyled = styled(Typography.Paragraph)<TParagraphStyleProps>`
    margin-bottom: 0 !important;
    font-weight: ${props => FONT_WEIGHTS[props.$weight]};
    text-align: ${props => props.$textAlign};
    ${props => FONT_VARIANTS[props.$variant]};
`;
